import { render, staticRenderFns } from "./project-create.vue?vue&type=template&id=13adf4e4&scoped=true"
import script from "./project-create.vue?vue&type=script&lang=js"
export * from "./project-create.vue?vue&type=script&lang=js"
import style0 from "./project-create.vue?vue&type=style&index=0&id=13adf4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13adf4e4",
  null
  
)

export default component.exports